import MergeTable from './MergeTable';
export default MergeTable;
